import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import logo from "../../assets/images/logo.png";

const CONTENT = {
  ne: {
    tagline1: 'नगरको समृद्धि र दिगो विकासका लागि नगरवासीको सामुहिक प्रयास।',
    tagline2: 'सुन्दर, शान्त र समृद्ध इटहरीका लागि।',
    addressLine1: 'इटहरी, सुनसरी',
    addressLine2: 'कोशी प्रदेश, नेपाल',
    email: 'bholikoitahari@gmail.com',

    platformHeading: 'Platform',
    participateHeading: 'Participate',
    downloadsHeading: 'डाउनलोडहरू',
    downloadsDesc: 'प्रतिवेदन, फारम, नक्सा, नीति, रिपोर्टलगायत विभिन्न उपयोगी दस्तावेजहरू',
    downloadsBtn: 'हेर्नुहोस्',

    platformLinks: [
      { to: '/', label: 'गृहपृष्ठ' },
      { to: '/events', label: 'इभेन्ट' },
      { to: '/downloads', label: 'डाउनलोड' },
      { to: '/about', label: 'हाम्रो बारेमा' },
    ],
    volunteer: 'स्वयंसेवक बन्नुहोस्',
    participateLinks: [
      { to: '/feedback', label: 'प्रतिक्रिया दिनुहोस्' },
    ],
    rights: '© 2026 भोलिको इटहरी। सर्वाधिकार सुरक्षित।',
    privacy: 'गोपनीयता',
    terms: 'सर्तहरू',
  },
  en: {
    tagline1: 'A collective effort by the people of the city for its prosperity and sustainable development.',
    tagline2: 'For a beautiful, peaceful, and prosperous Itahari.',
    addressLine1: 'Itahari, Sunsari',
    addressLine2: 'Koshi Province, Nepal',
    email: 'bholikoitahari@gmail.com',

    platformHeading: 'Platform',
    participateHeading: 'Participate',
    downloadsHeading: 'Downloads',
    downloadsDesc: 'Useful documents including reports, forms, maps, policies, and more.',
    downloadsBtn: 'View',

    platformLinks: [
      { to: '/', label: 'Home' },
      { to: '/events', label: 'Events' },
      { to: '/downloads', label: 'Downloads' },
      { to: '/about', label: 'About Us' },
    ],
    volunteer: 'Become a Volunteer',
    participateLinks: [
      { to: '/feedback', label: 'Give Feedback' },
    ],
    rights: '© 2026 Bholiko Itahari. All rights reserved.',
    privacy: 'Privacy',
    terms: 'Terms',
  },
};

const Footer = () => {
  const { language } = useLanguage();
  const t = CONTENT[language];

  return (
    <footer className="bg-gray-900 text-white/65 mt-auto">
      <div className="max-w-[1200px] mx-auto px-6 pt-12 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr_1.2fr] gap-12 mb-10">

          {/* Brand */}
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-3">
              <img
                src={logo}
                alt="भोलिको इटहरी"
                className="w-[100px] h-[100px] object-contain"
              />
            </div>
            <p className="text-[0.82rem] text-white/45 max-w-[260px]">
              {t.tagline1}<br />
              {t.tagline2}
            </p>

            {/* Address + Email */}
            <div className="text-[0.8rem] text-white/40 mt-1 flex flex-col gap-1">
              <span>{t.addressLine1}, {t.addressLine2}</span>
              
              <a  href={`mailto:${t.email}`}
                className=" text-amber-400 hover:text-white transition-colors duration-200"
              >
                {t.email}
              </a>
            </div>

            {/* Social Icons */}
            <div className="flex gap-3 mt-1">

              <a href="https://www.facebook.com/bholikoitahari"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-white/[0.06] text-white/50 hover:bg-white/10 hover:text-white transition-colors duration-200"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.51 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.44 2.91h-2.34V22c4.78-.76 8.44-4.92 8.44-9.94Z" />
                </svg>
              </a>

              <a href="https://tiktok.com/@yourpage"
                target="_blank"
                rel="noreferrer"
                aria-label="TikTok"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-white/[0.06] text-white/50 hover:bg-white/10 hover:text-white transition-colors duration-200"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16.6 5.82c-.9-.98-1.4-2.26-1.4-3.62h-3.15v13.72a3.16 3.16 0 1 1-2.24-3.02v-3.24a6.31 6.31 0 1 0 5.39 6.24V9.4a8.35 8.35 0 0 0 4.9 1.57V7.83a4.85 4.85 0 0 1-3.5-2.01Z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Platform */}
          <div>
            <h4 className="text-[0.72rem] uppercase tracking-[0.12em] text-green-400/70 font-semibold mb-3">
              {t.platformHeading}
            </h4>
            <ul className="flex flex-col gap-2">
              {t.platformLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className="font-[var(--ff-nepali)] text-[0.88rem] text-white/50 hover:text-white transition-colors duration-200">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Participate */}
          <div>
            <h4 className="text-[0.72rem] uppercase tracking-[0.12em] text-green-400/70 font-semibold mb-3">
              {t.participateHeading}
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/volunteer" target="_blank" rel="noreferrer"
                  className="font-[var(--ff-nepali)] text-[0.95rem] text-white/50 hover:text-white transition-colors duration-200">
                  {t.volunteer}
                </Link>
              </li>
              {t.participateLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className="font-[var(--ff-nepali)] text-[0.88rem] text-white/50 hover:text-white transition-colors duration-200">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Downloads */}
          <div>
            <h4 className="text-[0.72rem] uppercase tracking-[0.12em] text-green-400/70 font-semibold mb-3">
              {t.downloadsHeading}
            </h4>
            <p className="text-[0.8rem] text-white/40 mb-3">
              {t.downloadsDesc}
            </p>
            <Link
              to="/downloads"
              className="inline-block text-[0.82rem] text-green-400/80 hover:text-green-300 transition-colors duration-200"
            >
              {t.downloadsBtn} →
            </Link>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="pt-5 border-t border-white/[0.08] flex justify-between items-center flex-wrap gap-2 text-[0.76rem] text-white/30">
          <span>{t.rights}</span>
          <div className="flex gap-5 items-center">
            <span className="text-white/20">Powered by <span className="text-amber-400 font-semibold">Kafals</span></span>
            <Link to="/privacy" className="text-white/30 hover:text-white/70 transition-colors duration-200">{t.privacy}</Link>
            <Link to="/terms" className="text-white/30 hover:text-white/70 transition-colors duration-200">{t.terms}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;